// extracted by mini-css-extract-plugin
module.exports = {"root":"dd31006766--root--wJk6k","mobile":"dd31006766--mobile--m8Cah"};